import classNames from "classnames";
import styles from "../style.module.scss";
import { useEffect, useState } from "react";
import { GetAllTransactions } from "shared/services/transactions";
import { TransactionType } from "shared/utils/enum";
import CustomPagination from "shared/components/common/customPagination";
import CustomTable from "shared/components/common/customTable";
import CustomToolTip from "shared/components/common/customToolTip";
import SkeletonLoader from "shared/loaders/skeleton";
import { Icons } from "assets";
const SubscriptionTransactions = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [totalItems, setTotalItems] = useState<number>(0);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleGetAllTransactionns(page);
  };

  const imagesTableHeads = [
    { title: "#", key: "sr" },
    { title: "Transaction Id", key: "id" },
    { title: "Buyer", key: "from_user" },
    { title: "Total", key: "total" },
    { title: "Action", key: "action" },
  ];

  const handleGetAllTransactionns = async (page: number) => {
    setLoading(true);
    GetAllTransactions({
      page: page,
      limit: 10,
      type: TransactionType.SUBSCRIPTION,
    })
      .then(({ status, data: { data } }) => {
        if (status) {
          setTransactions(data?.data);
          setTotalItems(data?.meta?.totalItems);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAllTransactionns(1);
  }, []);

  return (
    <div className={classNames(styles.sectionContainer)}>
      <div className={classNames(styles.header)}></div>
      <div className={classNames(styles.tableWrapper, "relative")}>
        <CustomTable
          heads={imagesTableHeads}
          title="Transactions"
          isEmpty={!loading && !transactions.length}
        >
          {loading
            ? Array.from({ length: 2 }).map((_, index) => (
                <TableRowLoader key={index} />
              ))
            : transactions.map((data, idx) => (
                <tr key={data.id}>
                  <td>{idx + 1}</td>
                  <td>{data?.id}</td>
                  <td>{data?.from_user?.name}</td>
                  <td>${(data?.total / 100).toFixed(2)}</td>

                  <td className="">
                    <div className={classNames(styles.IconsContainer)}>
                      <CustomToolTip label="Release">
                        <button
                          onClick={() => {
                            window.open(data?.hosted_invoice_url, "_blank");
                          }}
                        >
                          <Icons.Eye />
                        </button>
                      </CustomToolTip>
                    </div>
                  </td>
                </tr>
              ))}
        </CustomTable>
      </div>

      <CustomPagination
        onPageChange={handlePageChange}
        totalCount={totalItems}
        currentPage={currentPage}
        pageSize={10}
      />
    </div>
  );
};

const TableRowLoader = () => (
  <tr>
    {Array.from({ length: 5 }).map((_, index) => (
      <td
        key={index}
        className={classNames(styles.tableContentLabel, "px-2 py-3")}
      >
        <div className="flex items-center justify-center">
          <SkeletonLoader className={styles.lineLoader} />
        </div>
      </td>
    ))}
  </tr>
);

export default SubscriptionTransactions;
